


export const AI_MENU = {
  id: 'ai',
  key: '2',
  title: 'AI智能助手',
  children: [],
  pagePath: ['/technicalSupport/ai'],
  iconUrl: require('@/assets/images/support/ai-menu-icon.png')
}


export const FAE_MENU = {
  id: 'fae',
  key: '3',
  title: 'FAE项目',
  iconUrl: require('@/assets/images/support/fae-menu-icon.png'),
  children: [
    {
      id: 'project',
      key: '3-1',
      pagePath: ['/technicalSupport/fae/project'],
      title: '我的项目',
      children: []
    }, {
      id: 'order',
      key: '3-2',
      pagePath: ['/technicalSupport/fae/order', '/technicalSupport/fae/order/submit'],
      title: '我的工单',
      children: []
    }
  ]
}

export const MENU_PERMISSION_LIST = [{
  code: 'ai',
  menu: AI_MENU
},
{
  code: 'fae',
  menu: FAE_MENU
}
]


export const BASE_PERMISSION_CODE = 'developer-technicalSupport'